import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaArrowLeft } from 'react-icons/fa';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="min-vh-100 d-flex align-items-center">
      <Row className="w-100">
        <Col className="text-center">
          <div className="error-page">
            <h1 className="display-1 text-primary mb-4">404</h1>
            <h2 className="mb-3">Página não encontrada</h2>
            <p className="lead text-muted mb-4">
              A página que você está procurando não existe ou foi movida.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Button 
                variant="primary" 
                onClick={() => navigate(-1)}
                className="d-flex align-items-center gap-2"
              >
                <FaArrowLeft />
                Voltar
              </Button>
              <Button 
                variant="outline-primary" 
                onClick={() => navigate('/')}
                className="d-flex align-items-center gap-2"
              >
                <FaHome />
                Início
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
